/**
 * @Descriptions:密码公钥
 * @Author: dsn
 * @Date: 2020/3/28
 */
var rsaPublicKey = '-----BEGIN PUBLIC KEY-----\n' + 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDFK8/0WUrI+n4aCaP4DQpF0lW5h28iNrGJwTkf/eJAYFhJ3lzWb7WlYJvz/3+kPq0/SHbTP0DtAvFQwb5PfrZqaJF5aBt8XGHbe7DNp6PRDrpTbcuKOg+xpZn9nBoNEB8MSL/eWprKPK3QXD1KjZzxeWB3VhmTWg8vKA4cMM+cVwIDAQAB\n' + '-----END PUBLIC KEY-----';
export default rsaPublicKey;